import React from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Video from "yet-another-react-lightbox/plugins/video";
import "yet-another-react-lightbox/plugins/thumbnails.css";

const ImageViewer = ({ slides, isOpen, onClose }) => {
  const formattedSlides = Array.isArray(slides)
    ? slides.map((slide) => {
        const src = slide.src.startsWith("http") && slide.src;

        const isVideo = /\.(mp4|webm|ogg)$/i.test(src);
        if (isVideo) {
          return {
            type: "video",
            sources: [
              {
                src,
                type: `video/${src.split(".").pop().toLowerCase()}`,
              },
            ],
            width: slide.width || 1920,
            height: slide.height || 1080,
            autoPlay: slide.autoPlay || false,
            controls: slide.controls !== undefined ? slide.controls : true,
          };
        }
        return {
          ...slide,
          src,
          width: slide.width || 1920,
          height: slide.height || 1080,
        };
      })
    : [];


  return (
    <div>
      <Lightbox
        open={isOpen}
        close={onClose}
        slides={formattedSlides}
        plugins={[Fullscreen, Thumbnails, Zoom, Video]}
        zoom={{
          maxZoomPixelRatio: 3,
          scrollToZoom: true,
        }}
        thumbnails={{
          position: "bottom",
          width: 120,
          height: 80,
        }}
      />
    </div>
  );
};

export default ImageViewer;
